export default __webpack_public_path__ + "static/media/hartford_.d18ce486.jpg";